/* eslint-disable @typescript-eslint/await-thenable */

import { createModel, RematchDispatch, RematchRootState } from '@rematch/core';
import { RootModel } from '.';
import { PwWebConection, Service, TabData, TabState } from '../types';
import { buildServiceUrls } from '../utils/builders';
import { parseEntityId } from '../utils/parsers';

const initialTabState: TabState = {
  tabData: undefined,
  embedUrl: undefined,
  linkToUrl: undefined,
  tabName: '',
};

export const tab = createModel<RootModel>()({
  state: initialTabState,
  reducers: {
    setEmbedUrl(state: TabState, payload: string | undefined): TabState {
      return {
        ...state,
        embedUrl: payload,
      };
    },
    setLinkToUrl(state: TabState, payload: string | undefined): TabState {
      return {
        ...state,
        linkToUrl: payload,
      };
    },
    setTabData(state: TabState, payload: TabData): TabState {
      return {
        ...state,
        tabData: payload,
      };
    },
    setTabName(state: TabState, payload: string): TabState {
      return {
        ...state,
        tabName: payload,
      };
    },
  },
  effects: (dispatch: RematchDispatch<RootModel>) => ({
    async loadTabUrls(
      subEntityId: string | undefined,
      rootState: RematchRootState<RootModel>
    ): Promise<void> {
      try {
        if (!rootState.services.service?.buddiUrl) return;
        const { embedUrl, linkToUrl } = await buildServiceUrls({
          projectId: rootState.projects.project.id,
          service: rootState.services.service,
          connectionId: rootState.connections.connection?.id,
          iModel: rootState.imodels.iModel,
          defaultRoute: rootState.services.defaultRoute,
          subEntityId,
        });
        this.setEmbedUrl(embedUrl);
        this.setLinkToUrl(linkToUrl);
      } catch (error) {
        dispatch.global.handleError({ error });
      }
    },
    async loadStateFromTabData(
      context: microsoftTeams.Context,
      rootState: RematchRootState<RootModel>
    ): Promise<void> {
      this.setTabData(parseEntityId(context.entityId));
      await dispatch.tab.loadStateFromLegacyTabData(context);
      await dispatch.projects.loadProjectFromTabData({});
      await dispatch.services.loadServiceFromTabData({});
      await dispatch.tab.loadTabUrls(context.subEntityId);
    },

    async loadStateFromLegacyTabData(
      context: microsoftTeams.Context,
      rootState: RematchRootState<RootModel>
    ): Promise<void> {
      const tabData = parseEntityId(context.entityId);
      if (!rootState.tab.tabData) {
        this.setTabData(tabData);
      }

      dispatch.connections.setConnection({
        id: tabData.connectionId ?? '',
        name: tabData.connectionName ?? '',
      } as PwWebConection);

      dispatch.services.setService({
        internalName: tabData.serviceName,
      } as Service);

      dispatch.tab.setEmbedUrl(tabData.embedUrl ?? '');
      dispatch.tab.setLinkToUrl(tabData.linkToUrl ?? '');
    },
  }),
});
